export default __webpack_public_path__ + "6ddd9cbbdeb6c4c4765744e2fc2cc7c0.png";